export const dropdown = () => {
  $(".css--dropdown > a").on("click touch", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).toggleClass("is-active");
    $(".css--dropdown .css--dropdown--body").toggleClass("active");
  });

  $(document).on("click touch", function (e) {
    $(".css--dropdown > a").toggleClass("is-active");
    $(".css--dropdown .css--dropdown--body").removeClass("active");
  });
};
